

export const ERROR_CODE_CONTAINER = 'error-container';
export const SCREEN_READER_TEXT = 'screen-reader-text';
export const NUMBER_FOUR_CLASS = 'four';
export const NUMBER_ZERO_CLASS = 'zero';
export const LINK_CONTAINER_BTN = "link-container";